<template>
  <base-popover-with-line v-bind="$attrs" :show="showPopover">
    <template #popover>
      <div class="base-popover-for-new-function-0" v-if="mode === 0">
        <div class="title">{{title}}</div>
        <div class="desc">{{desc}}</div>
        <div class="footer">
          <div class="know-btn" @click="onKnow">我知道了</div>
          <div class="confirm-btn" @click="onSubmit">立即体验</div>
        </div>
      </div>
      <div class="base-popover-for-new-function-1" v-if="mode === 1">
        <div class="title">{{title}}</div>
        <div class="know-btn" @click="onKnow">我知道了</div>
      </div>
    </template>
    <slot></slot>
  </base-popover-with-line>
</template>

<script>
import BasePopoverWithLine from './base-popover-with-line.vue';

export default {
  components: {
    BasePopoverWithLine,
  },
  props: {
    title: String,
    desc: String,
    storageKey: String,
    mode: {
      type: Number,
      default: 0, // 0: 有两个按钮的样式， 1：一行更短的蓝色样式，
    },
  },
  data() {
    return {
      showPopover: false,
    };
  },
  computed: {},
  created() {
    const hasShowed = localStorage.getItem(this.storageKey);
    if (!hasShowed) {
      this.showPopover = true;
    }
  },
  methods: {
    onKnow() {
      localStorage.setItem(this.storageKey, 1);
      this.showPopover = false;
    },
    onSubmit() {
      this.onKnow();
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="less" scoped>
.base-popover-for-new-function-0{
  width: 240px;
  padding: 12px;
  line-height: 1;
  .title{
    color: #2F333D;
    font-size: 14px;
    font-weight: 600;
  }
  .desc{
    margin-top: 8px;
    font-size: 12px;
    line-height: 18px;
    color: #2F333D;
  }
  .footer{
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .know-btn{
      color: #91999F;
      font-size: 12px;
      cursor: pointer;
    }
    .confirm-btn{
      margin-left: 8px;
      width: 68px;
      height: 24px;
      background: #599FFF;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
    }
  }
}

.base-popover-for-new-function-1{
  padding: 6px 8px 6px 12px;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  white-space: nowrap;
  .know-btn{
    width: 64px;
    height: 20px;
    background: #FFFFFF;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #599FFF;
    margin-left: 24px;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/popover/base-popover-for-new-function.vue